/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* The pieces of an job file
*/
export class V1DownloadJobFileResponse {
    /**
    * The file bytes.
    */
    'chunk'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "string",
            "format": "byte"
        }    ];

    static getAttributeTypeMap() {
        return V1DownloadJobFileResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

